module.exports = __webpack_public_path__ + "img/background.5825f033.svg";